<template>
  <div class="build views" :class="{ 'is-menu-embedded': isMenuEmbedded }" :style="isMenuEmbedded ? { backgroundColor: config.backgroundColor || '#1e1f1e' } : {}">
    <div v-if="navigationError" class="screen-navigation-error" role="alert">
      <span>{{ navigationError }}</span><button type="button" @click="navigationError = ''">关闭提示</button>
    </div>
    <p class="screen-navigation-status" role="status" aria-live="polite">当前页面：{{ currentPageName }}<span v-if="navigationContext.productId">，产品 {{ navigationContext.productId }}</span><span v-if="navigationContext.deviceId">，设备 {{ navigationContext.deviceId }}</span></p>
    <container ref="container"></container>
  </div>
</template>
<script>
import init from '@/mixins/'
import pageNavigation from '@/mixins/page-navigation'
export default {
  mixins: [init, pageNavigation],
  data() {
    return { liveProjectPreview: false }
  },
  computed: {
    isMenuEmbedded () { return this.$route.query.embedded === '1' }
  },
  watch: {
    isMenuEmbedded: { immediate: true, handler (value) {
      if (typeof document !== 'undefined') document.documentElement.classList.toggle('screen-menu-embedded', value)
    } }
  },
  created() {
    if (this.$route.query.token) localStorage.setItem("x-access-token", this.$route.query.token);
    if (!this.isPreview) window.initWebSocket()
    else if (!this.isSharedView && !this.isTemplatePreview) {
      // 快照中的模板标记由容器解析；在节点渲染前按已加载模型决定是否连接，避免重复读取快照。
      this._previewSocketWatch = this.$watch(() => [this.projectRecord, this.obj], () => {
        if (this.$route.name !== 'view' || !this.isPreview ||
            this.isSharedView || this.isTemplatePreview || !this.projectRecord ||
            this.projectRecord.id !== this.$route.params.id || !this.obj || this.obj.templatePreview === true) {
          this.liveProjectPreview = false
          return
        }
        this.liveProjectPreview = true
        if (this._previewSocketInitialized) return
        this._previewSocketInitialized = true
        window.initWebSocket()
      }, { immediate: true })
    }
  },
  beforeDestroy() {
    if (typeof document !== 'undefined') document.documentElement.classList.remove('screen-menu-embedded')
    if (this._previewSocketWatch) this._previewSocketWatch()
    this.liveProjectPreview = false
  }
}
</script>
<style lang="scss">
@import "../styles/style.scss";
html.screen-menu-embedded, .screen-menu-embedded body, .screen-menu-embedded #app, .screen-menu-embedded .app-route-surface { width: 100%; height: 100%; margin: 0; overflow: hidden; }
.views.is-menu-embedded { position: fixed; inset: 0; width: 100%; height: 100%; overflow: hidden; }
.screen-navigation-status { position: absolute; width: 1px; height: 1px; overflow: hidden; clip-path: inset(50%); margin: 0; }
.screen-navigation-error { position: fixed; top: 12px; left: 12px; right: 12px; z-index: 10001; padding: 12px 16px; border: 1px solid #c77749; background: #342a24; color: #fff2e5; display: flex; align-items: center; gap: 12px; font-size: 14px; }
.screen-navigation-error span { min-width: 0; overflow-wrap: anywhere; }
.screen-navigation-error button { margin-left: auto; flex-shrink: 0; min-height: 36px; background: transparent; color: inherit; border: 1px solid #c77749; cursor: pointer; }
.screen-page-action { position: absolute; inset: 0; width: 100%; height: 100%; z-index: 9; background: transparent; padding: 0; border: 0; cursor: pointer; }
.screen-page-action:disabled { cursor: default; }
.screen-page-action:focus-visible { outline: 2px solid #00d8ff; outline-offset: -3px; }
</style>
